import React from 'react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { PointIcon } from 'src/shared/components/icons/point-icon'
import { Users } from 'src/shared/components/icons/users'
import { Button } from 'src/shared/components/ui/buttons/button'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'
import { useIsCurrentUser } from 'src/shared/hooks/use-is-current-user'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'
interface BannerSectionProps {
  user: PublicUserData
}

export const BannerSection: React.FC<BannerSectionProps> = ({ user }) => {
  const isMobile = useIsMobile()
  const isCurrentUser = useIsCurrentUser(user.id)

  return (
    <div className={cn('flex items-center gap-2', isMobile ? 'flex-row' : 'flex-col')}>
      <div className="flex gap-2">
        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold">{user.networkSize}</span>
          <Users className="size-3.5" />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-lg font-semibold">{user.totalPoints}</span>
          <PointIcon className="size-3.5" />
        </div>
      </div>

      {isCurrentUser && (
        <Link to={paths.network.getHref()}>
          <Button variant="accent" size="sm" className="h-7 px-3 text-xs" leftIcon={<Users className="size-3" />}>
            Network
          </Button>
        </Link>
      )}
    </div>
  )
}

export default BannerSection
